<template>
  <div>

    <modal
      :title="$t('titles.download_transactions_report')"
      :submit="submit"
    >

      <v-checkbox
        :label="$t('titles.include_summary_row')"
        v-model="formState.include_summary_row"
        persistent-hint
        hint="If checked, the total gross revenue, net revenue, and number of transactions will be included as the last row of the report."
      />

    </modal>

  </div>
</template>

<script setup lang="ts">

import { reactive } from 'vue'

// @ts-ignore
import { closeDialog } from 'vue3-promise-dialog'
import type { TransactionsDownloadOptions } from './types'

const formState = reactive({
  include_summary_row: false,
})

function submit() {
  const options: TransactionsDownloadOptions = {
    include_summary_row: formState.include_summary_row,
  }
  closeDialog(options)
}

</script>
